import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserService } from './core/user/user.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {

    constructor(private _userServie:UserService) {
        /**
         * To hide console & warning on inspect element
         */
        // console.log = function () { };
        // console.warn = function () { };
    }

    ngOnInit() {
        // this._userServie.getSettings().subscribe();
        // this._userServie.setUser({id:'1',name:"Vinay Kumar",email:'vinay.kumar@ciphersquare.tech',designation:'Employee',avatar:'images/avatars/male-04.jpg'})
    }

}
